let catIpObserver: MutationObserver | null = null;

const catIpCopy = {
  intro:
    '星芒负责建立可跨越多种风格系列的长期品牌识别；猫咪则承载 AngelMyth 女孩“甜美与冷感并存”的双面性格——亲近时温柔黏人，陌生时冷静有边界。爱心与四叶草作为辅助符号，为情感表达和系列变化提供补充。',
  name: '猫咪 · 甜酷双面人格IP',
  position:
    '猫咪不是单纯的可爱符号，而是 AngelMyth 女孩的性格镜像：外表甜美、神情偏酷；熟悉时温柔黏人、爱撒娇和贴贴，面对陌生关系时则冷静克制、有边界感，呈现冷感大女主气场。',
  roles: [
    '建立“亲近模式”与“陌生模式”两套表情和动作：一面撒娇、贴贴、柔软温和；一面冷脸、独处、克制有边界。',
    '以圆润线条、爱心与贴近动作表达甜美亲昵，以冷银金属、锐利眼神、不对称结构表达独立冷感。',
    '围绕“她对你熟不熟”制造双面反差内容，让消费者在温柔黏人与冷感大女主之间找到自己的情绪投射。'
  ],
  tags: ['甜酷猫系', '撒娇贴贴', '冷脸表情', '亲近模式', '陌生模式'],
  architecture: '双面人格、反差表达、形成情绪共鸣'
};

function replaceText(element: Element | null | undefined, value: string) {
  if (element && element.textContent !== value) element.textContent = value;
}

function applyCatIpAdjustment() {
  const catCard = document.querySelector<HTMLElement>('.brand-ip-card.cat');
  if (!catCard) return;

  replaceText(document.querySelector('.brand-ip-intro'), catIpCopy.intro);
  replaceText(catCard.querySelector('.brand-ip-name'), catIpCopy.name);
  replaceText(catCard.querySelector('.brand-ip-position'), catIpCopy.position);

  const roleDescriptions = catCard.querySelectorAll('.brand-ip-role span');
  catIpCopy.roles.forEach((copy, index) => replaceText(roleDescriptions[index], copy));

  const tags = catCard.querySelectorAll('.brand-ip-product-tags span');
  catIpCopy.tags.forEach((copy, index) => replaceText(tags[index], copy));

  const architectureItems = document.querySelectorAll('.brand-ip-architecture-item');
  const catArchitecture = Array.from(architectureItems).find(item =>
    item.querySelector('b')?.textContent?.includes('猫咪')
  );
  replaceText(catArchitecture?.querySelector('span'), catIpCopy.architecture);
}

export function mountCatIpAdjustment() {
  applyCatIpAdjustment();
  if (catIpObserver) return;

  catIpObserver = new MutationObserver(applyCatIpAdjustment);
  catIpObserver.observe(document.body, { childList: true, subtree: true });
}
